export const REDUCER_NAME = "getbillingSlice";

export interface iBillingListItem {
  id: string;
  companyname: string;
  billingemail: string;
  phonenumber: string;
  gstin: string;
  address: string;
  city: string;
  state: string;
  country: string;
  pincode: string;
  created_at: string;
  updated_at: string | null;
}